/**
 * Get the Maps settings from the server.
 */

/**
 * WordPress dependencies
 */
import apiFetch from '@wordpress/api-fetch';
import { addQueryArgs } from '@wordpress/url';

/**
 * The Maps settings type
 *
 * @typedef	{Object}	Settings	{
 * 		MapSettings
 * @property {google.maps.MapOptions}          settings The map settings
 * @property {google.maps.LatLngBoundsLiteral} bounds   The map bounds
 * @property {google.maps.MapTypeStyle[]}      styles   The map styles
 * @property {string|false}                    marker   The marker URL
 *                                                      }
 */
interface Settings {
	settings: google.maps.MapOptions;
	bounds: google.maps.LatLngBoundsLiteral;
	styles: google.maps.MapTypeStyle[];
	marker?: string | false;
}

/**
 * Get settings from the API
 *
 * @param {string} page  The page ID
 * @param {block}  block The block ID
 * @return	{Promise<Settings>}	The map settings
 */
const getSettings = ( page: string, block: string ) => {
	/**
	 * The API URL path
	 *
	 * @param {string} path The API path
	 */
	const path = addQueryArgs( '/stockistmap/v1/settings', {
		page,
		block,
	} );

	return apiFetch< Settings >( { path } );
};

export default getSettings;
